import { useQuery } from '@apollo/client';
import { PAGE_VERSION } from './pageEditorCache';

const usePageVersion = ({ pageId, versionId }) => {
  const { data, loading } = useQuery(PAGE_VERSION, {
    variables: { pageId, versionId },
    skip: !pageId || !versionId,
  });

  return {
    version: data?.pageVersion || null,
    loading,
  };
};

export default usePageVersion;
